import { createFileRoute, notFound } from '@tanstack/react-router'
import {
  getLegalDocumentContent,
  isLegalDocumentId,
} from '~/features/compliance/legal-content'
import { LegalPage } from '~/features/compliance/legal-page'
import { resolveImplementedLocale } from '~/lib/i18n/shared'
import { seo } from '~/utils/seo'

export const Route = createFileRoute('/$locale/_public/legal/$document')({
  beforeLoad: ({ params }) => {
    if (!isLegalDocumentId(params.document)) {
      throw notFound()
    }
    return {
      document: params.document,
      locale: resolveImplementedLocale(params.locale),
    }
  },
  head: ({ params }) => {
    if (!isLegalDocumentId(params.document)) {
      return {}
    }
    const locale = resolveImplementedLocale(params.locale)
    const content = getLegalDocumentContent(locale, params.document)
    return seo({
      title: `${content.title} — BallPeek`,
      description: content.summary,
      pathname: `/legal/${params.document}`,
      locale,
    })
  },
  component: LegalDocumentRoute,
})

function LegalDocumentRoute() {
  const { document, locale } = Route.useRouteContext()
  return <LegalPage locale={locale} document={document} />
}
